import React, { Component } from "react";
import "./housingloanhome.css";
import { t } from "i18next";
import * as Bl from "../../../businesslogic";
import housingLoan from "../../../assets/svgs/housing_loan.svg";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import { getLiabilityPathName, getUserId } from "../../common";
import { LIABILITIES_CATEGORY } from "../../constants";

const newLiability = {
  userid: "",
  liabilitiescategory: LIABILITIES_CATEGORY.HOUSE_LOAN,
  description: "",
  loanissuedby: "",
  maturityyear: 0,
  currentvalue: 0,
  maturityage: 0,
  isincludefinancialplan: false
};
class HousingLoanHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer: false,
      liabilityData: [],
      newLiabilityData: new Bl.Liability({...newLiability, userid: getUserId()}),
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddProperty() {
    this.props.navigate("/housingloandetail", {
      state: { liabilityData: this.state.newLiabilityData, isEditView: false },
    });
  }



  renderNavView() {
    const items = getLiabilityPathName("HousingLoan");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("hlTitle");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="hhome_profile_view">
        <img src={housingLoan} alt={"Housing Loan"} className="hhome_icon" />
        <div className="hhome_info_view">
          {t("hlInfo")}
        </div>
        <div className="hhome_add_property">
          <Button
            buttonName={t("hlButton")}
            onPressButton={this.onPressAddProperty.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderContentView() {
    return (
      <div className="hhome_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  render() {
    return (
      <div className="hhome_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default HousingLoanHome;
